import { AxiosError } from 'axios';
import { errorNotification } from '../../utils/notifications';

interface FetchError {
    detail: string;
    instance: string;
    status: number;
    title: string;
    type: string;
    invalidParams: Array<InvalidParams>;
}

interface InvalidParams {
    reason: string;
}

export async function handleFetchError(errorResponse: Response, fallbackMessage: string) {
    try {
        const error = (await errorResponse.json()) as FetchError;
        if (error) {
            if (error.invalidParams) {
                errorNotification(error.invalidParams[0].reason);
            } else if (error.detail) {
                errorNotification(error.detail);
            } else {
                errorNotification(fallbackMessage);
            }
        }
    } catch (err) {
        try {
            const fallback = await errorResponse.text();
            errorNotification(fallback || fallbackMessage);
        } catch {
            errorNotification(fallbackMessage);
        }
        // workaround because there is a bug in package @plusng/react-common-components
        // errorResponse.json() throws an exception because body stream is already read
        if (!(err instanceof TypeError)) {
            console.error('An unexpected error occurred during error handling.');
        }
    }
}

export async function handleAxiosError(error: AxiosError, fallbackMessage: string) {
    try {
        const responseData = error.response?.data as FetchError;

        if (Array.isArray(responseData?.invalidParams) && responseData.invalidParams[0]?.reason) {
            errorNotification(responseData.invalidParams[0].reason);
        } else if (responseData?.detail) {
            errorNotification(responseData.detail);
        } else if (typeof responseData === 'string') {
            errorNotification(responseData);
        } else {
            errorNotification(fallbackMessage);
        }
    } catch (err) {
        errorNotification(fallbackMessage);
        throw err;
    }
}
